import { FormikErrors } from "formik";
import { scrollToFirstError } from "./scrollToFirstError";

export interface SubmitWithScrollParams<T = Record<string, any>> {
  initialValues: T;
  validateForm: (values?: any) => Promise<FormikErrors<T>>;
  setTouched: (
    touched: Record<string, boolean>,
    shouldValidate?: boolean
  ) => void;
  submitForm: () => void;
}

export const handleSubmitWithScroll = async <T = Record<string, any>>({
  initialValues,
  validateForm,
  setTouched,
  submitForm,
}: SubmitWithScrollParams<T>) => {
  const formErrors = await validateForm();

  if (formErrors && Object.keys(formErrors).length > 0) {
    const allTouched: Record<string, boolean> = {};
    Object.keys(initialValues as Record<string, any>).forEach((key) => {
      allTouched[key] = true;
    });

    // Also mark error keys as touched (they may not be in initialValues when coming from Yup .test())
    Object.keys(formErrors).forEach((key) => {
      allTouched[key] = true;
    });

    setTouched(allTouched);

    setTimeout(() => {
      scrollToFirstError(formErrors, allTouched);
    }, 100);

    return false;
  }

  submitForm();
  return true;
};
